var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect10, _path2, _path3, _path4, _rect11, _rect12, _mask, _path5, _mask2, _path6, _mask3, _path7, _rect13, _mask4, _path8, _mask5, _path9, _mask6, _path10, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _mask7, _path11, _mask8, _path12, _mask9, _path13, _rect22, _mask10, _path14, _mask11, _path15, _mask12, _path16, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _mask13, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrickWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 240,
    viewBox: "0 0 399 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 146.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 26.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 201.5,
    y: 146.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 201.5,
    y: 26.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 146.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 26.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 116.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 146.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 26.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227 116.5C227.828 116.5 228.5 117.172 228.5 118V138C228.5 139.933 226.933 141.5 225 141.5H173C171.067 141.5 169.5 139.933 169.5 138V118C169.5 117.172 170.172 116.5 171 116.5C171.828 116.5 172.5 117.172 172.5 118V120.689C172.5 122.298 173.358 123.784 174.751 124.588L196.751 137.28C198.143 138.083 199.857 138.083 201.249 137.28L223.249 124.588C224.642 123.784 225.5 122.298 225.5 120.689V118C225.5 117.172 226.172 116.5 227 116.5Z",
    stroke: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 116.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141 86.5H172.84C175.39 86.5 176.341 89.8433 174.173 91.1855C173.133 91.8295 172.5 92.9662 172.5 94.1895V108C172.5 109.933 170.933 111.5 169 111.5H141C139.067 111.5 137.5 109.933 137.5 108V90C137.5 88.1273 138.971 86.5984 140.82 86.5049L141 86.5Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173 56.5H225C226.933 56.5 228.5 58.067 228.5 60V78C228.5 79.933 226.933 81.5 225 81.5H207.062C206.454 81.5 205.855 81.3411 205.326 81.0391L201.232 78.7002C199.849 77.9097 198.151 77.9097 196.768 78.7002L192.674 81.0391C192.145 81.3411 191.546 81.5 190.938 81.5H173C171.067 81.5 169.5 79.933 169.5 78V60C169.5 58.067 171.067 56.5 173 56.5Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257 86.5H225.16C222.61 86.5 221.659 89.8433 223.827 91.1855C224.867 91.8295 225.5 92.9662 225.5 94.1895V108C225.5 109.933 227.067 111.5 229 111.5H257C258.933 111.5 260.5 109.933 260.5 108V90C260.5 88.1273 259.029 86.5984 257.18 86.5049L257 86.5Z",
    stroke: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 146.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 26.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-1_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 146H1C3.20914 146 5 147.791 5 150V168C5 170.209 3.20914 172 1 172H0V146Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 145H1C3.76142 145 6 147.239 6 150H4C4 148.343 2.65685 147 1 147H0V145ZM6 168C6 170.761 3.76142 173 1 173H0V171H1C2.65685 171 4 169.657 4 168H6ZM0 172V146V172ZM1 145C3.76142 145 6 147.239 6 150V168C6 170.761 3.76142 173 1 173V171C2.65685 171 4 169.657 4 168V150C4 148.343 2.65685 147 1 147V145Z",
    fill: "#3C3E4C",
    mask: "url(#path-17-inside-1_1649_3504)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-2_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 26H1C3.20914 26 5 27.7909 5 30V48C5 50.2091 3.20914 52 1 52H0V26Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25H1C3.76142 25 6 27.2386 6 30H4C4 28.3431 2.65685 27 1 27H0V25ZM6 48C6 50.7614 3.76142 53 1 53H0V51H1C2.65685 51 4 49.6569 4 48H6ZM0 52V26V52ZM1 25C3.76142 25 6 27.2386 6 30V48C6 50.7614 3.76142 53 1 53V51C2.65685 51 4 49.6569 4 48V30C4 28.3431 2.65685 27 1 27V25Z",
    fill: "#3C3E4C",
    mask: "url(#path-19-inside-2_1649_3504)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-3_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 86H1C3.20914 86 5 87.7909 5 90V108C5 110.209 3.20914 112 1 112H0V86Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 85H1C3.76142 85 6 87.2386 6 90H4C4 88.3431 2.65685 87 1 87H0V85ZM6 108C6 110.761 3.76142 113 1 113H0V111H1C2.65685 111 4 109.657 4 108H6ZM0 112V86V112ZM1 85C3.76142 85 6 87.2386 6 90V108C6 110.761 3.76142 113 1 113V111C2.65685 111 4 109.657 4 108V90C4 88.3431 2.65685 87 1 87V85Z",
    fill: "#3C3E4C",
    mask: "url(#path-21-inside-3_1649_3504)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 116.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-4_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 116H33C35.2091 116 37 117.791 37 120V138C37 140.209 35.2091 142 33 142H0V116Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 115H33C35.7614 115 38 117.239 38 120H36C36 118.343 34.6569 117 33 117H0V115ZM38 138C38 140.761 35.7614 143 33 143H0V141H33C34.6569 141 36 139.657 36 138H38ZM0 142V116V142ZM33 115C35.7614 115 38 117.239 38 120V138C38 140.761 35.7614 143 33 143V141C34.6569 141 36 139.657 36 138V120C36 118.343 34.6569 117 33 117V115Z",
    fill: "#3C3E4C",
    mask: "url(#path-24-inside-4_1649_3504)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-5_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 56H33C35.2091 56 37 57.7909 37 60V78C37 80.2091 35.2091 82 33 82H0V56Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55H33C35.7614 55 38 57.2386 38 60H36C36 58.3431 34.6569 57 33 57H0V55ZM38 78C38 80.7614 35.7614 83 33 83H0V81H33C34.6569 81 36 79.6569 36 78H38ZM0 82V56V82ZM33 55C35.7614 55 38 57.2386 38 60V78C38 80.7614 35.7614 83 33 83V81C34.6569 81 36 79.6569 36 78V60C36 58.3431 34.6569 57 33 57V55Z",
    fill: "#3C3E4C",
    mask: "url(#path-26-inside-5_1649_3504)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-6_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 176H33C35.2091 176 37 177.791 37 180V198C37 200.209 35.2091 202 33 202H0V176Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 175H33C35.7614 175 38 177.239 38 180H36C36 178.343 34.6569 177 33 177H0V175ZM38 198C38 200.761 35.7614 203 33 203H0V201H33C34.6569 201 36 199.657 36 198H38ZM0 202V176V202ZM33 175C35.7614 175 38 177.239 38 180V198C38 200.761 35.7614 203 33 203V201C34.6569 201 36 199.657 36 198V180C36 178.343 34.6569 177 33 177V175Z",
    fill: "#3C3E4C",
    mask: "url(#path-28-inside-6_1649_3504)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 86.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 86.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 56.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 176.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 56.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 176.5,
    width: 59,
    height: 25,
    rx: 3.5,
    stroke: "#3C3E4C"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 388 146)",
    stroke: "#3C3E4C"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 388 26)",
    stroke: "#3C3E4C"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-7_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398 146H397C394.791 146 393 147.791 393 150V168C393 170.209 394.791 172 397 172H398V146Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M398 145H397C394.239 145 392 147.239 392 150H394C394 148.343 395.343 147 397 147H398V145ZM392 168C392 170.761 394.239 173 397 173H398V171H397C395.343 171 394 169.657 394 168H392ZM398 172V146V172ZM397 145C394.239 145 392 147.239 392 150V168C392 170.761 394.239 173 397 173V171C395.343 171 394 169.657 394 168V150C394 148.343 395.343 147 397 147V145Z",
    fill: "#3C3E4C",
    mask: "url(#path-38-inside-7_1649_3504)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-8_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398 26H397C394.791 26 393 27.7909 393 30V48C393 50.2091 394.791 52 397 52H398V26Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M398 25H397C394.239 25 392 27.2386 392 30H394C394 28.3431 395.343 27 397 27H398V25ZM392 48C392 50.7614 394.239 53 397 53H398V51H397C395.343 51 394 49.6569 394 48H392ZM398 52V26V52ZM397 25C394.239 25 392 27.2386 392 30V48C392 50.7614 394.239 53 397 53V51C395.343 51 394 49.6569 394 48V30C394 28.3431 395.343 27 397 27V25Z",
    fill: "#3C3E4C",
    mask: "url(#path-40-inside-8_1649_3504)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-9_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398 86H397C394.791 86 393 87.7909 393 90V108C393 110.209 394.791 112 397 112H398V86Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M398 85H397C394.239 85 392 87.2386 392 90H394C394 88.3431 395.343 87 397 87H398V85ZM392 108C392 110.761 394.239 113 397 113H398V111H397C395.343 111 394 109.657 394 108H392ZM398 112V86V112ZM397 85C394.239 85 392 87.2386 392 90V108C392 110.761 394.239 113 397 113V111C395.343 111 394 109.657 394 108V90C394 88.3431 395.343 87 397 87V85Z",
    fill: "#3C3E4C",
    mask: "url(#path-42-inside-9_1649_3504)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 356 116)",
    stroke: "#3C3E4C"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-10_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398 116H365C362.791 116 361 117.791 361 120V138C361 140.209 362.791 142 365 142H398V116Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M398 115H365C362.239 115 360 117.239 360 120H362C362 118.343 363.343 117 365 117H398V115ZM360 138C360 140.761 362.239 143 365 143H398V141H365C363.343 141 362 139.657 362 138H360ZM398 142V116V142ZM365 115C362.239 115 360 117.239 360 120V138C360 140.761 362.239 143 365 143V141C363.343 141 362 139.657 362 138V120C362 118.343 363.343 117 365 117V115Z",
    fill: "#3C3E4C",
    mask: "url(#path-45-inside-10_1649_3504)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-47-inside-11_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398 56H365C362.791 56 361 57.7909 361 60V78C361 80.2091 362.791 82 365 82H398V56Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M398 55H365C362.239 55 360 57.2386 360 60H362C362 58.3431 363.343 57 365 57H398V55ZM360 78C360 80.7614 362.239 83 365 83H398V81H365C363.343 81 362 79.6569 362 78H360ZM398 82V56V82ZM365 55C362.239 55 360 57.2386 360 60V78C360 80.7614 362.239 83 365 83V81C363.343 81 362 79.6569 362 78V60C362 58.3431 363.343 57 365 57V55Z",
    fill: "#3C3E4C",
    mask: "url(#path-47-inside-11_1649_3504)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-12_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398 176H365C362.791 176 361 177.791 361 180V198C361 200.209 362.791 202 365 202H398V176Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M398 175H365C362.239 175 360 177.239 360 180H362C362 178.343 363.343 177 365 177H398V175ZM360 198C360 200.761 362.239 203 365 203H398V201H365C363.343 201 362 199.657 362 198H360ZM398 202V176V202ZM365 175C362.239 175 360 177.239 360 180V198C360 200.761 362.239 203 365 203V201C363.343 201 362 199.657 362 198V180C362 178.343 363.343 177 365 177V175Z",
    fill: "#3C3E4C",
    mask: "url(#path-49-inside-12_1649_3504)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 324 86)",
    stroke: "#3C3E4C"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 388 86)",
    stroke: "#3C3E4C"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 292 56)",
    stroke: "#3C3E4C"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 292 176)",
    stroke: "#3C3E4C"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 228 176)",
    stroke: "#3C3E4C"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 356 56)",
    stroke: "#3C3E4C"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59,
    height: 25,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 356 176)",
    stroke: "#3C3E4C"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-58-inside-13_1649_3504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.517 95V121L199 134L176.483 121V95L199 82L221.517 95ZM177.483 95.5771V120.422L199 132.845L220.517 120.422V95.5771L199 83.1543L177.483 95.5771Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M221.517 95H222.517V94.4227L222.017 94.134L221.517 95ZM221.517 121L222.017 121.866L222.517 121.577V121H221.517ZM199 134L198.5 134.866L199 135.155L199.5 134.866L199 134ZM176.483 121H175.483V121.577L175.983 121.866L176.483 121ZM176.483 95L175.983 94.134L175.483 94.4227V95H176.483ZM199 82L199.5 81.134L199 80.8453L198.5 81.134L199 82ZM177.483 95.5771L176.983 94.7111L176.483 94.9998V95.5771H177.483ZM177.483 120.422H176.483V120.999L176.983 121.288L177.483 120.422ZM199 132.845L198.5 133.711L199 133.999L199.5 133.711L199 132.845ZM220.517 120.422L221.017 121.288L221.517 120.999V120.422H220.517ZM220.517 95.5771H221.517V94.9998L221.017 94.7111L220.517 95.5771ZM199 83.1543L199.5 82.2883L199 81.9996L198.5 82.2883L199 83.1543ZM221.517 95H220.517V121H221.517H222.517V95H221.517ZM221.517 121L221.017 120.134L198.5 133.134L199 134L199.5 134.866L222.017 121.866L221.517 121ZM199 134L199.5 133.134L176.983 120.134L176.483 121L175.983 121.866L198.5 134.866L199 134ZM176.483 121H177.483V95H176.483H175.483V121H176.483ZM176.483 95L176.983 95.866L199.5 82.866L199 82L198.5 81.134L175.983 94.134L176.483 95ZM199 82L198.5 82.866L221.017 95.866L221.517 95L222.017 94.134L199.5 81.134L199 82ZM177.483 95.5771H176.483V120.422H177.483H178.483V95.5771H177.483ZM177.483 120.422L176.983 121.288L198.5 133.711L199 132.845L199.5 131.979L177.983 119.556L177.483 120.422ZM199 132.845L199.5 133.711L221.017 121.288L220.517 120.422L220.017 119.556L198.5 131.979L199 132.845ZM220.517 120.422H221.517V95.5771H220.517H219.517V120.422H220.517ZM220.517 95.5771L221.017 94.7111L199.5 82.2883L199 83.1543L198.5 84.0203L220.017 96.4432L220.517 95.5771ZM199 83.1543L198.5 82.2883L176.983 94.7111L177.483 95.5771L177.983 96.4432L199.5 84.0203L199 83.1543Z",
    fill: "white",
    mask: "url(#path-58-inside-13_1649_3504)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrickWall);
export default __webpack_public_path__ + "static/media/Brick_Wall.378c1d2910cbe073503c3d3823f10ab9.svg";
export { ForwardRef as ReactComponent };